export function getCountryCode(countryName) {
  return countryName === "Mexico"
    ? "MLM"
    : countryName === "Colombia"
      ? "MLC"
      : countryName === "Brasil"
        ? "MLB"
        : "MLA";
}
